import * as React from 'react';
import { connect } from 'react-redux';
import { NavLink, Redirect } from 'react-router-dom';
import { loginRequest, facebookRequest } from '../actions/auth';
import { withTranslation } from 'react-i18next';
import ReactFacebookLogin from 'react-facebook-login';
import Axios, { AxiosResponse } from 'axios';
import config from '../config';
import Helmet from 'react-helmet';

interface IInputs {
    username: string,
    password: string,
    [key: string]: any
};

interface IState {
    inputs: IInputs,
    errors: IInputs,
    redirectToCabinet: boolean,
    isLoading: boolean,
    [key: string]: any
};

class Login extends React.Component<any, any> {
    private _isUnmounted: boolean = false;

    public state: IState = {
        inputs: {
            username: "",
            password: "",

        },
        errors: {
            username: "",
            password: "",

        },
        redirectToCabinet: false,
        isLoading: false,
    }

    componentWillUnmount(){
        this._isUnmounted = true;
    }

    validateInput(name: string, value: string) {

        return new Promise<any>((ok: any, error: any): any => {
            this.setState({
                errors: {
                    ...this.state.errors,
                    [name]: value == "" ? (this.props.t("Необходимо заполнить") + " «" + this.props.t(name) + "»") : ""
                }
            }, () => {
                ok();
            });
        });
    }

    changeHandler(event: any) {
        let name = event.target.name;
        let value = event.target.value;

        this.validateInput(name, value).then(() => {
            this.setState({
                inputs: {
                    ...this.state.inputs,
                    [name]: value
                }
            });
        });
    }

    async submitHandler(event: any) {
        let hasError = false;

        for (let property in this.state.inputs) {
            await this.validateInput(property, this.state.inputs[property]);
        }

        for (let property in this.state.errors) {
            if (this.state.errors[property] != "") {
                hasError = true;
                break;
            }
        }

        if (!hasError) {
            this.setState({
                isLoading: true
            }, async () => {
                let response = await this.props
                    .loginRequest({
                        username: this.state.inputs.username,
                        password: this.state.inputs.password
                    });

                if (response.data.status == "error") {
                    this.setState({
                        errors: {
                            username: response.data.message
                        },
                        isLoading: false
                    });
                }
            });



        }
    }

    async facebookCallback(res: any) {
        try {
            if (!this._isUnmounted)
                this.setState({
                    // isLoading: true
                }, async () => {
                    let response = await this.props
                        .facebookRequest({
                            user_id: res.userID,
                            email: res.email,
                            first: res.name.split(" ").shift(),
                            last: res.name.split(" ").pop(),
                            gender: 0
                        });

                    if (response.data.status == "error") {
                        if (!this._isUnmounted)
                            this.setState({
                                errors: {
                                    username: response.data.message
                                },
                                isLoading: false
                            });
                    }
                });
        } catch (err) {
            this.setState({
                isLoading: false
            });
        }
    }

    render() {

        const { t } = this.props;

        return (
            <div className="i-body">
                <Helmet>
                    <title>{t("Вход") + " | " + window.location.host.toUpperCase() + " - Медиа портал в TAS-IX"}</title>
                </Helmet>
                
                <div className="container login-page v-index">
                    {this.state.redirectToCabinet || this.props.auth.isAuthentificated && <Redirect to="/" />}
                    <div className="wrapper">
                        <div className="box">
                            <div className="row">
                                <div className="col-lg-4 col-lg-push-4">
                                    <h2 className="text-header mt-0 mb-3 text-center">{t("Вход")}</h2>
                                    <form onSubmit={(e: any) => {
                                        e.preventDefault();

                                        this.submitHandler(e);
                                    }}>

                                        <div className="form-group field-loginform-username required">
                                            <input name="username" type="text" onChange={(e: any) => this.changeHandler(e)} onBlur={(e: any) => this.changeHandler(e)} value={this.state.inputs.username} className="form-control" placeholder={t("Почта *")} />
                                            <p className="help-block help-block-error text-danger">{this.state.errors.username}</p>
                                        </div>
                                        <div className="form-group field-loginform-password required">
                                            <input name="password" type="password" onChange={(e: any) => this.changeHandler(e)} onBlur={(e: any) => this.changeHandler(e)} value={this.state.inputs.password} className="form-control" placeholder={t("Пароль *")} />
                                            <p className="help-block help-block-error text-danger">{this.state.errors.password}</p>
                                        </div>
                                        <div className="form-group field-loginform-rememberme text-center">
                                            <label className="custom-control custom-radio">
                                                <input type="checkbox" id="loginform-rememberme" className="custom-control-input"
                                                    name="rememberMe" value="1" />
                                                <span className="custom-control-indicator"></span>
                                                <span className="custom-control-description"> {t("Запомни меня")} </span>
                                            </label>
                                            {/* <a className="pull-right text-danger" href="/ru/site/request-password-reset">
                                                {t("Забыли пароль?")}
                                            </a> */}

                                        </div>
                                        <div className="text-center">
                                            <button type="submit" className="btn btn-primary" style={{ padding: "10px 20px" }}>
                                                {this.state.isLoading ? (
                                                    <i className="fa fa-spinner fa-2x rotating "></i>
                                                ) : t("Вход")}
                                            </button>
                                        </div>
                                    </form>
                                    <div className="w-100 login-inner text-center pt-10">
                                        {t("Войти через")}:
                                        <ul className="auth-socials mt-5">

                                            <li>
                                                <ReactFacebookLogin
                                                    appId="484418995246707"
                                                    autoLoad={false}
                                                    fields="name,email,gender"
                                                    onClick={() => { }}
                                                    callback={(response) => { this.facebookCallback(response) }}
                                                    icon="fa-facebook-official fa-3x"
                                                    textButton=""
                                                    cssClass="facebook-auth text-primary"
                                                />
                                            </li>

                                            {/* <li>
                                                <a >
                                                    <i className="fa fa-google-plus-official fa-3x text-danger"></i>
                                                </a>
                                            </li> */}
                                        </ul>
                                    </div>
                                    <div className="w-100 text-center text-description mt-20">
                                        {t("У вас нету аккаунта?")} {" "}
                                        <NavLink className="text-success" to="/signup"> <b> {t("Регистрация")} </b> </NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        auth: state.auth
    };
}

export default connect(mapStateToProps, { loginRequest, facebookRequest })(withTranslation()(Login));